import http from '../utils/http'
// PGC列表
export function pgcListAPI(data) {
    return http.post('/select/pgcList', data)
}
// 用户组列表
export function groupListApi(data, params) {
    return http.post('/select/groupList',data, params)
}
// 标签列表
export function lableListApi(params) {
    return http.get('/select/lableList', params)
}
// 圈子数据管理
export function forumDataAPI(data) {
    return http.post('/select/forumData', data)
}